<!-- 电信案例 电子渠道整体解决方案-->
<template>
  <div class="case">
    <h4 class="current">
      您的位置：<router-link to="/home">首页 </router-link> &gt;产品与方案 &gt; 电子渠道整体解决方案
    </h4>
    <div class="article">
      <h5>电子渠道整体解决方案</h5>
      <h4 class="smalltit">产品简介</h4>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电子渠道是以互联网技术和通信技术为基础，将产品的销售与服务数字化，客户借助终端设备，可自主订购产品、获取服务。它是整体渠道体系的重要组成部分，与实体渠道互为补充、相互结合，形成多层次、立体化的电子营销服务渠道体系。电子渠道定位于营销和服务。内部为各级业务部门提供服务和销售的支撑，外部为用户提供7*24小时不受地域限制的服务，也面向代理商提供业务办理、统计查询、佣金查询等服务。
      </p>
      <h4 class="smalltit">产品架构</h4>
      <img src="@/assets/dianxin001-1.png" />
      <h4 class="smalltit">产品亮点</h4>
      <p>
        <span class="boldblack">1.能力开放</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;整合电信行业的统一客户身份鉴权、统一支付、统一业务办理、故障申报等核心业务支撑能力，作为企业的客户运营能力API提供给合作伙伴，方便其业务的快速接入，实现标准化业务管理和便捷的业务结算，助力生态业务应用的快速构建和推广。
        <br /><span class="boldblack">2.智慧营销</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;打通大数据和运营支撑体系，充分利用客户标签、客户画像、产品标签等数据资产，依托实时/批量的计算能力、事件引擎等技术手段，构建场景化、全触点的数据驱动和场景驱动的实时营销能力，提升数据运营能力以及客户服务水平，实现数据资产的加速变现。
        <br /><span class="boldblack">3.接入快速</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;平台提供开放式架构，只需按照接入平台规范提供原子服务即可实现接入，可快速集成自身及外部能力为上层提供能力支撑。
        <br /><span class="boldblack">4.扩展性强</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;分布式架构使能力中心可根据需要进行整合和拆分，支撑能力中心快速的部署和扩展。
      </p>
      <h4 class="smalltit">产品价值</h4>
      <p>
        <span class="boldblack">（一）多门户、多渠道</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过网上营业厅、客户端、短信营业厅、微信营业厅等构建全面的企业门户、个人门户和合作伙伴门户，把企业、客户和合作伙伴紧密的联系在一起。
        <br /><span class="boldblack">（二）提升服务</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;透过自助服务、体验式营销、社交式营销等手段，简化业务受理、服务提供的流程与等待，使客户体验更美好。
        <br /><span class="boldblack">（三）降低成本</span><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;移动化的服务渠道，不仅能降低实体店的日常运营压力，还能减少实体店投入和物力成本等，提升企业运营水平与效率。
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
h4.current {
  display: block;
  height: 40px;
  line-height: 30px;
  background: url(../../../assets/currentbg.jpg) repeat-x bottom;
  color: #333;
}
h4.current a:hover {
  color: #e90000;
}
.article h5 {
  display: block;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  color: #333;
  margin-top: 40px;
}
.article h6 {
  display: block;
  text-align: center;
  font-size: 14px;
  color: #888;
  margin-top: 5px;
  margin-bottom: 30px;
}
.smalltit {
  display: block;
  height: 55px;
  line-height: 55px;
  margin-top: 20px;
  padding-left: 35px;
  background: url(../../../assets/ico01.png) no-repeat left center;
  font-size: 22px;
  color: #e60212;
}
.intro p {
  line-height: 30px;
}
.intro img {
  display: block;
  margin: 0 auto;
}
.article img {
  margin: 0 auto;
  display: block;
  margin-top: 15px;
}
.article p {
  margin-top: 15px;
  line-height: 30px;
  margin: 15px 0;
}
.boldblack {
  color: #333;
  font-weight: bold;
}
.boldred {
  color: #f00;
  font-weight: bold;
}
.font18 {
  font-size: 18px;
}
</style>
